import * as React from "react";
const RenameSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 4a1 1 0 0 1 1-1h2v1H3v10h2v1H3a1 1 0 0 1-1-1V4Zm3 5V7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v2h-1V7H9v4h.997v1H7v-1h1V7H6v2H5Zm9-6a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-2v-1h2V4h-2V3h2Z" }));
RenameSmall.displayName = "RenameSmall";
var RenameSmall_default = RenameSmall;
export {
  RenameSmall_default as default
};
